import cn from "classnames"

import { useGetTenantConfigurations } from "@/api/useTenant"
import { Button } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Kai } from "@/icons"
import { useKai } from "@/organisms/KaiChat"

import styles from "./KaiButton.module.scss"

import { KaiButtonProps } from "."

export const KaiButton = (props: KaiButtonProps) => {
  const { t } = useTranslation()
  const { open, toggle } = useKai()
  const { response } = useGetTenantConfigurations()
  const kaiChatbot = response?.data?.kaiChatbot
  const isDisabled = props.disabled || open

  if (!kaiChatbot) return null

  const className = isDisabled
    ? styles.disabled
    : cn(styles.button, styles.animation)

  return (
    <Button
      disabled={isDisabled}
      className={className}
      icon={<Kai />}
      type={isDisabled ? "default" : "text"}
      size={props.size}
      onClick={toggle}
    >
      {t("kai.placeholders.askKai")}
    </Button>
  )
}
